<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Proportionsdiagram
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Segmenterat horisontellt stapeldiagram i Degkalkylatorn. Visar
      proportionerna för de olika ingredienserna.
    </p>

    <PreviewFull label="Segmenterad stapel + legend">
      <div>
        <!-- Bar -->
        <div class="flex h-5 rounded-full overflow-hidden w-full mb-4">
          <div
            v-for="item in items"
            :key="item.label"
            :style="{
              width: `${(item.value / total) * 100}%`,
              background: item.color,
            }"
          />
        </div>
        <!-- Legend -->
        <div class="flex flex-wrap gap-4">
          <div
            v-for="item in items"
            :key="item.label"
            class="flex items-center gap-1.5"
          >
            <span
              class="w-3 h-3 rounded-full flex-shrink-0"
              :style="{ background: item.color }"
            />
            <span class="font-[Plus_Jakarta_Sans] text-[13px] text-[#3c4947]">{{
              item.label
            }}</span>
            <span class="font-[Poppins] font-bold text-[13px] text-[#191c1e]"
              >{{ item.value }} g</span
            >
          </div>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Segmenterad stapel -->
<div class="flex h-5 rounded-full overflow-hidden w-full mb-4">
  <div
    v-for="item in items" :key="item.label"
    :style="{ width: \`\${(item.value / total) * 100}%\`, background: item.color }"
  />
</div>
<!-- Legend -->
<div class="flex flex-wrap gap-4">
  <div v-for="item in items" :key="item.label" class="flex items-center gap-1.5">
    <span class="w-3 h-3 rounded-full flex-shrink-0" :style="{ background: item.color }" />
    <span class="font-[Plus_Jakarta_Sans] text-[13px] text-[#3c4947]">{{ item.label }}</span>
    <span class="font-[Poppins] font-bold text-[13px] text-[#191c1e]">{{ item.value }} g</span>
  </div>
</div>`;
const cssCode = `/* Stapel-segment */
height: 20px;           /* h-5 */
border-radius: 9999px;  /* rounded-full */

/* Färger */
/* Mjöl:  */ background: #f59e0b;
/* Vatten: */ background: #0ea5e9;
/* Salt:   */ background: #94a3b8;
/* Jäst:   */ background: #a78bfa;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const items = [
  { label: "Mjöl", value: 500, color: "#f59e0b" },
  { label: "Vatten", value: 350, color: "#0ea5e9" },
  { label: "Salt", value: 10, color: "#94a3b8" },
  { label: "Jäst", value: 5, color: "#a78bfa" },
];
const total = items.reduce((s, i) => s + i.value, 0);
</script>
